export default __webpack_public_path__ + "static/media/cif-do.70a22f6e.svg";